import React from "react";
import styled from "styled-components";
import Image from "gatsby-image";

const BannerImage = styled.div`
  width: 100%;
`;

export default props => {
  const { bannerImage, alt } = props;

  return (
    <BannerImage>
      <Image
        fluid={bannerImage.localFile.childImageSharp.fluid}
        alt={alt || "image"}
      />
    </BannerImage>
  );
};
